import { B2bEnvironment } from './environment.interface';

// Environment genérico base para compilación Docker
// La configuración real se carga desde /assets/config/runtime-config.json en runtime
export const environment: B2bEnvironment = {
  production: true,
  URL_LINK_LOGO: 'https://www.asg-si.com',
  CLIENTE: 'generic',
  LOGO: 'assets/img/LOGOTIPOS_GEMMA_6_RESIZED.png', // Fallback genérico
  ICON: 'assets/img/asg/favicon.ico',
  TITLE: 'GemmaShop B2B',
  LOGO_BACKGROUND_COLOR: '#fff',
  SECTOR_BACKGROUND_COLOR: '#00bfa5',
  SERVER_IMG: '',
  IMG_EXTENSION: 'jpg',
  SERVER_USU_URL: '',
  SERVER_ART_URL: '',
  SERVER_PED_URL: '',
  SERVER_CLI_URL: '',
  SERVER_EAN_URL: '',
  SERVER_PORTAL_URL: '',
  OAUTH_URL_GMAUTH: '',
  OAUTH_URL_GMAUTH_ADMIN: '',
  AUTH_TOKEN: true,
  CLIENT_ID: '',
  CLIENT_SECRET: '',
  ADMIN_ID: '',
  PASSWORD_ADMIN: '',
  USERNAME_ADMIN: '',
  SERVER_ADM_URL: '',
  ADMIN_REALM: '',
  LOGIN_EMAIL: false,
  VER_PROD_LOGOUT: true,
  VER_REFERENCIA_LOGOUT: true,
  COMPRA_TB: true,
  TIPO_BULTO: 'U,F,C,K',
  TIPO_BULTO_DEF: 'C',
  PORTES: true,
  FSERVICIO: true,
  VER_CLICK_COLLECT: false,
  VER_CONFIRMA_COMPRA: true,
  VER_PVP_CAJA: false,
  VER_PVP_IVA: false,
  COMPRAR_SIN_STOCK: 'N',
  BOTON_COMPRA_BULTO: false,
  CLI_CATALOGO: 0,
  ALM_CATALOGO: 1,
  VER_LOGO_GMSHOP: false,
  TURNSTILE_CLOUDFLARE: false,
  TURNSTILE_SITE_KEY: '',
  FILTROS_SHOP: {
    novedad: true,
    miscompras: true,
    mascomprado: true,
    marcapropia: true,
    oferta: true,
    eslista: true,
    espedido: true
  },
  VER_CLASIFICACION: true,
  MENSAJE_COMPRA: '',
  MENSAJE_COMPRADO: 'Recibirá un correo electrónico con los datos del mismo. Dependiente de artículos de peso los importes son orientativos',
  VER_HOME: false,
  VER_HOME_LOGEADO: false,
  VER_PORTAL: true,
  LOGIN_IS_HOME: false,
  URL_LOGOUT: '',
  CANT_TOPE: 99,
  KILO_TOPE: 99,
  LOGIN_IMG: null,
  LOGIN_IMG_PROFILE_VIEW: true,
  MULTI_FOTOS: false,
  AGRUPACION: 'SECTOR',
  AYUDA_VIDEOS: [],
  REPORT_FCF: '',
  ART_PESO_VER_PESO: true,
  PORTAL_MENU: {
    factura: true,
    faltas: false,
    dec347: false,
    pagos: false,
    pendiente: false
  },
  REPORT_DEC347: '',
  COOKIE_VER: false,
  COOKIE_domain: '',
  COOKIE_header: '',
  COOKIE_message: '',
  COOKIE_dismiss: '',
  COOKIE_allow: '',
  COOKIE_deny: '',
  COOKIE_link: '',
  LOGIN_INTENTOS_AVISO: 3,
  COOKIE_cookiePolicyHref: '',
  COOKIE_policy: '',
  COOKIE_privacyPolicyHref: '',
  COOKIE_privacyGroupPolicyHref: '',
  PWD_MIN_LENGTH: 8,
  PWD_PATTERN: ''
};
